// Third Party Libraries
import { v4 as uuidV4 } from 'uuid';

const cart = {
	state: {
		subtotalPrice: null,
		totalPrice: null,
		selectedCartTable: null,
		selectedCartContent: [],
		selectedCartProducts: [],
		isCheckout: false,
		idempotencyKey: null,
		isCheckoutEnabled: false,
		isProductChanged: false,
		isProductDeactivated: false,
		isProductOutOfStock: false,
	},
	mutations: {
		setSubtotalPrice(state, subtotalPrice) {
			state.subtotalPrice = subtotalPrice;
		},
		setTotalPrice(state, totalPrice) {
			state.totalPrice = totalPrice;
		},
		setSelectedCartTable(state, selectedCartTable) {
			state.selectedCartTable = selectedCartTable;
		},
		setSelectedCartContent(state, cartContent) {
			state.selectedCartContent = cartContent;
		},
		setSelectedCartProducts(state, cartProducts) {
			state.selectedCartProducts = cartProducts;
		},
		setIsCheckoutFlag(state, flag) {
			state.isCheckout = flag;
		},
		setIdempotencyKey(state, key) {
			state.idempotencyKey = key;
		},
		setProductDeactivated(state, deactivated) {
			state.isProductDeactivated = deactivated;
		},
		setProductChanged(state, changed) {
			state.isProductChanged = changed;
		},
		setProductOutOfStock(state, valid) {
			state.isProductOutOfStock = valid
		},
		setCheckoutDisabled(state, isCheckoutEnabled) {
			state.isCheckoutEnabled = isCheckoutEnabled;
		},
		clearTotalPrice(state) {
			state.totalPrice = null;
		},
		clearSelectedCartTableAndContent(state) {
			state.selectedCartTable = null;
			state.selectedCartContent = [];
		},
		clearIdempotencyKey(state) {
			state.idempotencyKey = null;
		},
		resetIsProductDeactivated(state) {
			state.isProductDeactivated = false;
		},
		resetIsProductChanged(state) {
			state.isProductChanged = false;
		}
	},
	actions: {
		generateIdempotencyKey({state, commit}) {
			commit('setIdempotencyKey', uuidV4());
		},
	},
	getters: {
		getSubtotalPrice(state) {
			return state.subtotalPrice;
		},
		getTotalPrice(state) {
			return state.totalPrice;
		},
		getSelectedCartTable(state) {
			return state.selectedCartTable;
		},
		getSelectedCartContent(state) {
			return state.selectedCartContent;
		},
		getCheckoutFlag(state) {
			return state.isCheckout;
		},
		getIdempotencyKey(state) {
			return state.idempotencyKey;
		},
		getIsCheckoutEnabled(state) {
			return state.isCheckoutEnabled;
		},
		getIsProductDeactivated(state) {
			return state.isProductDeactivated;
		},
		getIsProductChanged(state) {
			return state.isProductChanged;
		},
		getIsProductOutOfStock(state) {
			return state.isProductOutOfStock;
		}
	}
}

export default cart;